import React from "react";
import Icon from "../../atoms/common/icon/icon";
import {IconSource} from "../../../shared/enums/iconSource";
import classNames from "classnames";
import {Color} from "../../../shared/enums/color";
import "./haloIcon.sass";

export interface IHaloIconProps {
  iconSource: IconSource;
  haloColor: Color;
}

const HaloIcon: React.FC<IHaloIconProps> = ({iconSource, haloColor}) => {
  return (
    <div className={classNames(`halo-icon ${haloColor}`)}>
      <Icon source={iconSource} />
    </div>
  );
};

export default HaloIcon;
